module.exports = __webpack_public_path__ + "img/Vector 44.b2f4cfc6.png";